var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLikes100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.738 70.9999C140.738 109.435 109.593 140.58 71.1581 140.58C32.7235 140.58 1.57812 109.435 1.57812 70.9999C1.57812 32.5653 32.7235 1.41992 71.1581 1.41992C109.593 1.41992 140.738 32.5653 140.738 70.9999Z",
    fill: "url(#paint0_linear_1545_9262)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1514 118.763C70.2475 118.763 69.3847 118.393 68.7274 117.777L46.0072 95.0568C38.4064 87.4561 38.4064 75.1305 46.0072 67.5297C49.6638 63.8731 54.553 61.8188 59.7708 61.8188C63.9204 61.8188 67.8235 63.0925 71.1103 65.4754C78.7111 60.0111 89.3933 60.7095 96.2134 67.5297C99.87 71.1863 101.924 76.0754 101.924 81.2933C101.924 86.5111 99.9111 91.4002 96.2134 95.0568L73.4933 117.777C72.9181 118.393 72.0553 118.763 71.1514 118.763Z",
    fill: "#FFC25D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9262)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.1591,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#FFC25D",
    strokeWidth: 4.07895
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1545_9262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3183 24.437L66.3029 28.2438C66.2283 28.3931 66.1163 28.4677 65.9297 28.5051L61.675 29.2515C60.5181 29.4381 59.5477 30.2965 59.1745 31.4161C58.8013 32.5358 59.0998 33.7674 59.9209 34.6258L62.9066 37.7235C63.0186 37.8354 63.0559 37.9847 63.0559 38.134L62.4588 42.3887C62.2722 43.5456 62.7947 44.7399 63.7277 45.449C64.6981 46.1581 65.967 46.2701 67.012 45.7476L70.8935 43.8442C71.0427 43.7696 71.192 43.7696 71.3413 43.8442L75.2227 45.7476C76.3051 46.2701 77.5367 46.1581 78.507 45.449C79.4774 44.7399 79.9626 43.583 79.776 42.3887L79.1788 38.134C79.1415 37.9847 79.2161 37.8354 79.3281 37.7235L82.3138 34.6258C83.1349 33.7674 83.4335 32.5358 83.0603 31.4161C82.6871 30.2965 81.7167 29.4381 80.5597 29.2515L76.3051 28.5051C76.1558 28.4677 76.0065 28.3931 75.9319 28.2438L73.9165 24.437C73.3567 23.392 72.2743 22.7202 71.0801 22.7202C69.9604 22.7202 68.8781 23.3547 68.3183 24.437Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.447 37.0517L100.341 38.3206C100.192 38.358 100.043 38.358 99.8934 38.246L96.3852 35.7455C95.4149 35.0737 94.1459 34.9617 93.1009 35.5215C92.0559 36.044 91.3841 37.1264 91.3468 38.3206L91.2722 42.6126C91.2722 42.7619 91.1975 42.9112 91.0855 42.9858L87.652 45.561C86.7189 46.2701 86.2338 47.4644 86.4204 48.6214C86.607 49.7784 87.428 50.7487 88.5477 51.1593L92.6157 52.5401C92.765 52.5775 92.877 52.6894 92.9143 52.8387L94.2952 56.9814C94.6684 58.1011 95.6388 58.9221 96.8331 59.1087C97.99 59.2953 99.1843 58.8102 99.8934 57.8771L102.469 54.4435C102.543 54.3316 102.693 54.2569 102.842 54.2569L107.134 54.1823C108.328 54.1823 109.41 53.5105 109.933 52.4282C110.455 51.3832 110.381 50.1142 109.709 49.1439L107.246 45.6357C107.171 45.5237 107.134 45.3371 107.171 45.1878L108.44 41.0824C108.776 39.9628 108.477 38.7312 107.656 37.8728C106.835 37.0144 105.604 36.6785 104.447 37.0517Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8708 41.0452L35.1398 45.1506C35.1771 45.2998 35.1771 45.4491 35.0651 45.5984L32.6019 49.1066C31.9301 50.077 31.8182 51.3459 32.378 52.3909C32.9005 53.4359 33.9828 54.1077 35.1771 54.145L39.4691 54.2197C39.6184 54.2197 39.7676 54.2943 39.8423 54.4063L42.4175 57.8399C43.1266 58.7729 44.3209 59.2581 45.4778 59.0715C46.6348 58.8849 47.6052 58.0638 48.0157 56.9442L49.3966 52.8761C49.4339 52.7268 49.5459 52.6149 49.6952 52.5775L53.7632 51.1966C54.8829 50.8234 55.7039 49.8531 55.8905 48.6588C56.0771 47.5018 55.592 46.3075 54.6589 45.5984L51.2253 43.0232C51.1134 42.9486 51.0387 42.7993 51.0387 42.65L50.9641 38.3207C50.9641 37.1264 50.2923 36.0441 49.21 35.5216C48.165 34.9991 46.896 35.0737 45.9257 35.7455L42.4175 38.2461C42.3055 38.3207 42.1189 38.358 41.9696 38.3207L37.8642 37.0518C36.7446 36.7159 35.513 37.0145 34.6546 37.8355C33.7962 38.6939 33.4976 39.9255 33.8708 41.0452Z",
    fill: "#FFC25D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9262",
    x: 40.3066,
    y: 61.8188,
    width: 61.6172,
    height: 58.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9262"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9262",
    x: 7.73242,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9262"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1545_9262",
    x: 32.0195,
    y: 22.7202,
    width: 78.2559,
    height: 38.0598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9262",
    x1: 22.8781,
    y1: 16.5666,
    x2: 124.408,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLikes100);
export default __webpack_public_path__ + "static/media/IconLikes100.1ffecb6d8a3b4f1d933144542bd739ee.svg";
export { ForwardRef as ReactComponent };